import { IDotsCalendarProps } from "dots-ui/dotsCalendar";
import { AvisCalendar } from "./AvisCalendar";
import { useContext } from "react";
import { AvisContext } from "../../context/AvisContext";

export function AvisCalendarYear<T>(props: Readonly<IDotsCalendarProps<T>>) {
  const { res } = useContext(AvisContext);

  return (
    <AvisCalendar<T>
      view="year"
      mask="9999"
      {...props}
      placeholder={res("placeholder_DateYear")}
    />
  );
}
